module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Position-be43e966fdc945934b2d53d6fa46c33a.svg";